import { Route, Switch, useRouteMatch } from "react-router-dom";
import { MainAgentPrivacyNoticeView } from "../container/MRA/MainAgentApplication/MainAgentPrivacyNoticeView";
import { ResponsibilityConfirmationView } from "../container/MRA/MainAgentApplication/ResponsibilityConfirmationView";
import { RoleConfirmationView } from "../container/MRA/MainAgentApplication/RoleConfirmationView";
import { WorkExperienceConfirmationView } from "../container/MRA/MainAgentApplication/WorkExperienceConfirmationView";
import { ActiveLicenceConfirmationView } from "../container/MRA/MainAgentApplication/ActiveLicenceConfirmationView";
import { MRALicenceNumber } from "../container/MRA/MainAgentApplication/MRALicenceNumber";
import { AgentContactInformation } from "../container/MRA/MainAgentApplication/AgentContactInformation";
import { AgentDutiesConfirmation } from "../container/MRA/MainAgentApplication/AgentDutiesConfirmation";
import { AgentApplicationReview } from "../container/MRA/MainAgentApplication/AgentApplicationReview";
import { ApplicationSubmissionConfirmation } from "../container/MRA/MainAgentApplication/ApplicationSubmissionConfirmation";
import Navigation from "../container/Navigation";
import { ROUTE_PATH } from "./constants";
import { PreloadedRoute } from "./PreloadedRoute";
import { RegulatoryInfoConfirmationView } from "../container/MRA/MainAgentApplication/RegulatoryInfoConfirmationView";
import { ResidencyConfirmationView } from "../container/MRA/MainAgentApplication/ResidencyConfirmation";
import { AgeConfirmationView } from "../container/MRA/MainAgentApplication/AgeConfirmation";
import { LicenceTypeSelectionView } from "../container/MRA/MainAgentApplication/LicenceTypeSelectionView";
import { MainAgentLicenceInProvinces } from "../container/MRA/MainAgentApplication/MainAgentLicenceInProvinces";
import { MainAgentUploadWorkHistory } from "../container/MRA/MainAgentApplication/MainAgentUploadWorkHistory";
import { MainAgentMortgageBrokerInfo } from "../container/MRA/MainAgentApplication/MainAgentMortgageBrokerInfo";
import { MainAgentLicenceNumber } from "../container/MRA/MainAgentApplication/MainAgentLicenceNumber";
import { MainAgentCourseCertificateUpload } from "../container/MRA/MainAgentApplication/MainAgentCourseCertificateUpload";
import { MainAgentConfirmCompletionRegulatoryInfo } from "../container/MRA/MainAgentApplication/MainAgentConfirmCompletionRegulatoryInfo";
import { MainAgentCriminalRecordCheckUpload } from "../container/MRA/MainAgentApplication/MainAgentCriminalRecordCheckUpload";
import MainAgentPaymentPreview from "../container/MRA/MainAgentApplication/MainAgentPaymentPreview";
import { MainAgentNSLicenceNumber } from "../container/MRA/MainAgentApplication/MainAgentNSLicenceNumber";
import { MainAgentNSLicenceConfirmation } from "../container/MRA/MainAgentApplication/MainAgentNSLicenceConfirmation";
import { ComplianceOfficerDutiesConfirmation } from "../container/MRA/MainAgentApplication/ComplianceOfficerDutiesConfirmation ";

export const MortgageMainAgentApp = (props) => {
    let { path } = useRouteMatch();

    return (
    <>
        <Navigation {...props} />
        <Switch>
            <Route
                path={`${path}${ROUTE_PATH.MRA_PRIVACY_NOTICE}`}
                component={MainAgentPrivacyNoticeView}
            />
            <Route
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_REGULATORY_INFO_CONFIRMATION}`}
                component={RegulatoryInfoConfirmationView}
            />
            <Route
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_ROLE_CONFIRMATION}`}
                component={RoleConfirmationView}
            />
            <Route
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_WORK_EXPERIENCE_CONFIRMATION}`}
                component={WorkExperienceConfirmationView}
            />
            <Route
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_RESIDENCY_CONFIRMATION}`}
                component={ResidencyConfirmationView}
            />
            <Route
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_AGE_CONFIRMATION}`}
                component={AgeConfirmationView}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_LICENCE_TYPE_SELECTION}`}
                component={LicenceTypeSelectionView}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_LICENCE_IN_OTHER_PROVINCE}`}
                component={MainAgentLicenceInProvinces}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_LICENCE_NUMBER}`}
                component={MainAgentLicenceNumber}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_COURSE_CERTIFICATE_UPLOAD}`}
                component={MainAgentCourseCertificateUpload}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CONFIRM_COMPLETION_REGULATORY_INFO}`}
                component={MainAgentConfirmCompletionRegulatoryInfo}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_UPLOAD_WORK_HISTORY}`}
                component={MainAgentUploadWorkHistory}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_BROKER_INFORMATION}`}
                component={MainAgentMortgageBrokerInfo}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CRIMINAL_RECORD_DOCUMENT_UPLOAD}`}
                component={MainAgentCriminalRecordCheckUpload}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_RESPONSIBILITY_CONFIRMATION}`}
                component={ResponsibilityConfirmationView}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_ACTIVE_LICENCE_CONFIRMATION}`}
                component={ActiveLicenceConfirmationView}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CURRENT_MRA_NUMBER}`}
                component={MRALicenceNumber}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CONTACT_INFORMATION}`}
                component={AgentContactInformation}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_AGENT_DUTIES_CONFIRMATION}`}
                component={AgentDutiesConfirmation}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_COMPLIANCE_OFFICER_DUTIES_CONFIRMATION}`}
                component={ComplianceOfficerDutiesConfirmation}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_APPLICATION_REVIEW}`}
                component={AgentApplicationReview}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_APPLICATION_SUBMITTED}`}
                component={ApplicationSubmissionConfirmation}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CONFIRM_CURRENT_NS_LICENCE_NUMBER}`}
                component={MainAgentNSLicenceConfirmation}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CURRENT_NS_LICENCE_NUMBER}`}
                component={MainAgentNSLicenceNumber}
            />
            <PreloadedRoute
                path={`${path}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_PAYMENT_PREVIEW}`}
                component={MainAgentPaymentPreview}
            />
        </Switch>
    </>)
}